import React from 'react';
import { get } from '../../util/api';
import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import DirectionsIcon from '@mui/icons-material/Directions';
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const RefreshBtn = (props) => {
	const [loading, setLoading] = React.useState(false);
	function onclick() {
		setLoading(true);
		get('/maytapi/refreshSubscription/' + props.uid).then(() => {
			setLoading(false);
		});
	}

	return (
		<Button onClick={onclick} loading={loading}>
			<RefreshIcon />
		</Button>
	);
};

export default function Footprint() {
	const [loading, setLoading] = React.useState(true);
	const [data, setData] = React.useState({});

	React.useEffect(() => {
		get('/maytapi/admin/phoneList').then((temp) => {
			setLoading(false);
			const { phones, products } = temp;
			const map_pro = {},
				sub_pro = {};
			_.each(products, (it) => {
				map_pro[it.id] = it;
				if (it.sub)
					if (sub_pro[it.id]) sub_pro[it.id].push(it.sub);
					else sub_pro[it.id] = [it.sub];
			});
			setData({
				list: _.orderBy(
					_.map(_.filter(phones, { type: 'instagram' }), (it) => {
						it.product = map_pro[it.pid];
						it.sub = sub_pro[it.pid];
						it.subscription = it.product &&
							it.product.settings &&
							it.product.settings.subscription_package && [
								it.product.settings.subscription_package,
								it.product.settings.phone_limit,
								it.product.settings.agent_limit,
								it.product.settings.instagram_limit,
							];
						let token = (it.product && it.product.settings && it.product.settings.wapi_token) || temp.token;
						it.url = `https://api.maytapi.com/api/${it.pid}/${it.id}/screen?token=${token}`;
						it.token = token;
						it.copy_text = JSON.stringify(it, null, 2);
						return it;
					}),
					'id'
				),
			});
		});
	}, []);
	if (loading) return <Box attached="bottom">loading...</Box>;

	const { column, list, direction } = data;
	function handleSort(clickedColumn) {
		return () => {
			if (column !== clickedColumn) {
				setData({
					column: clickedColumn,
					list: _.sortBy(list, [clickedColumn]),
					direction: 'ascending',
				});

				return;
			}

			setData({
				column: clickedColumn,
				list: list.reverse(),
				direction: direction === 'ascending' ? 'descending' : 'ascending',
			});
		};
	}

	return (
		<Box attached="bottom">
			<Table sortable celled>
				<TableHead>
					<TableRow>
						<TableCell textAlign="center" style={{ width: 70 }} collapsing sorted={column === 'id' ? direction : null} onClick={handleSort('id')}>
							ID
						</TableCell>
						<TableCell sorted={column === 'pid' ? direction : null} onClick={handleSort('pid')}>
							Product
						</TableCell>
						<TableCell sorted={column === 'subscription' ? direction : null} onClick={handleSort('subscription')}>
							Subscription
						</TableCell>
						<TableCell sorted={column === 'status' ? direction : null} onClick={handleSort('status')}>
							Status
						</TableCell>
						<TableCell>Account</TableCell>
						<TableCell></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{_.map(list, (it) => {
						let { id, pid, product, number, auth, status, subscription, copy_text } = it;
						return (
							<TableRow key={id}>
								<TableCell textAlign="center">
									<CopyToClipboard text={copy_text}>
										<span>
											{id}
											<a href={it.url} target="_blank" rel="noopener noreferrer">
												<DirectionsIcon />
											</a>
										</span>
									</CopyToClipboard>
								</TableCell>
								<TableCell>
									{product ? (
										<a href={'/yta/logs?uid=' + product.uid} target="_blank" rel="noopener noreferrer">
											{product.email}
										</a>
									) : (
										pid
									)}
								</TableCell>

								<TableCell>
									{subscription && (
										<div>
											{subscription[0]} - [{'P:' + subscription[1] || 0},{'A:' + subscription[2] || 0},{'I:' + subscription[3] || 0}]
										</div>
									)}
								</TableCell>
								<TableCell>{status}</TableCell>
								<TableCell>{(number || auth) && `${number}, ${auth}`}</TableCell>

								<TableCell>{product && product.uid && <RefreshBtn uid={product.uid} />}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</Box>
	);
}
